import config from '@/services/config'
import storage from '@/services/storage'
import axios from 'axios'

const headers = {
  'Accept': 'application/json',
  'Content-Type': 'application/json',
  'X-Requested-With': 'Fetch',
  'accept-enconding': 'gzip'
}

const apiError = (request) => {
  // LOG ERRORS
  // use interceptor instead ?
  window.lastError = request
  console.warn('apiError', request)
  const responsedata = request.response && request.response.data || undefined
  request.responseMessage = responsedata && responsedata.message || request.message
  // propagate rejection
  return Promise.reject(request)
}

class API {

  constructor ({ baseURL }) {
    this.axios = axios.create({
      baseURL,
      headers
    })

    this.setToken(storage.get('token'))
  }

  setToken (token) {
    this.axios.defaults.headers['authorization'] = `Bearer ${token}`
  }

  get (url, params) {
    return this.request('get', url, null, { params: params })
  }

  put (url, data, config) {
    return this.request('put', url, data, config)
  }

  post (url, data, config) {
    return this.request('post', url, data, config)
  }

  delete (url, config) {
    return this.request('delete', url, null, config)
  }

  request (method, url, data, config) {
    console.log('request', method, url)
    return this.axios[method](url, data, config).catch(apiError)
  }

}

export default new API(config)



// WEBPACK FOOTER //
// ./src/services/api/api.js